/**
 * Обёртка над apiClient.
 *
 * Новые store'ы вызывают `api.get('/api/v1/...')` с относительными путями.
 * Чтобы гарантировать правильный baseURL и interceptors,
 * оборачиваем вызовы — на каждый запрос подставляем актуальный envUrls.api.
 */
import { apiClient, envUrls } from './api-client';
import type { AxiosRequestConfig, AxiosResponse } from 'axios';

function resolveUrl(url: string): string {
  // Если URL уже абсолютный — не трогаем
  if (url.startsWith('http://') || url.startsWith('https://')) return url;
  // Иначе подставляем актуальный API URL
  return `${envUrls.api}${url}`;
}

export const api = {
  get<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return apiClient.get(resolveUrl(url), config);
  },
  post<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return apiClient.post(resolveUrl(url), data, config);
  },
  put<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return apiClient.put(resolveUrl(url), data, config);
  },
  patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return apiClient.patch(resolveUrl(url), data, config);
  },
  delete<T = any>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<T>> {
    return apiClient.delete(resolveUrl(url), config);
  },
};

export { envUrls };
